<ngx-loading-bar [includeSpinner]="false"/>
@if (!loaded) {
  <div class="app-loading-cover">
    <div class="loader"></div>
  </div>
}
<router-outlet/>
@if ((isCookieBannerVisible$ | async)) {
  <app-cookie-consent class="cookie-consent-container"/>
}
